import React, { useEffect, useState } from "react";
import CampaignGroupPropType from "./campaign-group-prop-type";
import "./campaign-group-image-preview.styles.scss";

const propTypes = {
  campaignGroup: CampaignGroupPropType.isRequired
};

const CampaignGroupImagePreview = ({ campaignGroup }) => {
  const [iframeDimensions, setIframeDimensions] = useState({ width: 0, height: 0 });

  const calculateScaledDimensions = () => {
    const maxWidth = 200; // Max width for the iframe
    const maxHeight = 200; // Max height for the iframe
    const iframeWidth = campaignGroup.preview_width;
    const iframeHeight = campaignGroup.preview_height;

    const widthScale = maxWidth / iframeWidth;
    const heightScale = maxHeight / iframeHeight;
    const scale = Math.min(widthScale, heightScale);

    setIframeDimensions({
      width: iframeWidth * scale,
      height: iframeHeight * scale
    });
  };

  useEffect(() => {
    calculateScaledDimensions();
  }, []);

  return (
    <a
      href={
        campaignGroup.status === "draft"
          ? campaignGroup.finish_draft_link
          : campaignGroup.manage_campaign_link
      }
    >
      {campaignGroup.use_funnel_v2 ? (
        <div className="iframe-container">
          {["video", "video_referral", "video_real_estate", "ctv"].includes(
            campaignGroup.short_type
          ) ? (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video
              disablePictureInPicture
              autoPlay
              muted
              loop
              controls
              controlsList="nodownload noremoteplayback"
              className="border-0 ad-preview-iframe"
              src={campaignGroup.preview_video_url}
              width={iframeDimensions.width}
              height={iframeDimensions.height}
              data-testid="video"
            />
          ) : (
            <iframe
              title={`Campaign ${campaignGroup.campaign_id} preview`}
              className="border-0 ad-preview-iframe"
              sandbox="allow-scripts allow-same-origin"
              src={campaignGroup.preview_image_url}
              style={{ width: iframeDimensions.width, height: iframeDimensions.height }}
              scrolling="no"
            />
          )}
        </div>
      ) : (
        <img className="img-fluid mx-auto" alt="your ad" src={campaignGroup.preview_image_url} />
      )}
    </a>
  );
};

CampaignGroupImagePreview.propTypes = propTypes;

export default CampaignGroupImagePreview;
